export const initialState = {
  messages: [],
  totalMessages: []
};
